// eslint-disable-next-line @typescript-eslint/ban-ts-comment -- pi-lens/Deno resolver false positives on Expo/React workspace imports in this RN component; repo-native toolchain resolves these correctly
// @ts-nocheck
/**
 * CompactReadOnlyIndicators
 *
 * Read-only Context pill plus optional Experience pill shown when keyboard is visible.
 * Extracted from AnalysisSection.tsx (PR #242 audit).
 */
// @ts-expect-error -- pi-lens fallback Deno checker cannot resolve react-native workspace imports here
import { View, Platform } from "react-native";
// @ts-expect-error -- pi-lens fallback Deno checker cannot resolve local workspace package here
import { TierBody } from "@dramadetector/ui";
import { useTranslation } from "@dramadetector/shared";
import type { ContextType } from "../../../hooks/useMessageInput";
import type { TheatricalModeVariant } from "../../../lib/theatrical/theatricalModeConfig";

const CONTEXT_COLORS = {
	family: {
		bg: "rgba(6, 182, 212, 0.2)",
		border: "rgba(6, 182, 212, 0.3)",
		text: "#06b6d4",
	},
	work: {
		bg: "rgba(59, 130, 246, 0.2)",
		border: "rgba(59, 130, 246, 0.3)",
		text: "#3b82f6",
	},
	friends: {
		bg: "rgba(168, 85, 247, 0.2)",
		border: "rgba(168, 85, 247, 0.3)",
		text: "#a855f7",
	},
	dating: {
		bg: "rgba(236, 72, 153, 0.2)",
		border: "rgba(236, 72, 153, 0.3)",
		text: "#ec4899",
	},
} as const;

interface CompactReadOnlyIndicatorsProps {
	experienceMode?: TheatricalModeVariant;
	context: ContextType;
	showExperienceIndicator?: boolean;
}

export function CompactReadOnlyIndicators({
	experienceMode,
	context,
	showExperienceIndicator = true,
}: CompactReadOnlyIndicatorsProps) {
	const { t } = useTranslation("home");

	return (
		<View
			className="flex-row gap-3 mb-3"
			{...(Platform.OS === "web" && { "data-readonly-indicators": "true" })}
			style={{
				backgroundColor: "rgba(26, 26, 46, 0.8)",
				paddingVertical: 10,
				paddingHorizontal: 12,
				borderBottomWidth: 1,
				borderBottomColor: "rgba(255, 255, 255, 0.05)",
			}}
		>
			{/* Experience Indicator */}
			{showExperienceIndicator && experienceMode && (
				<View style={{ flex: 1 }}>
					<TierBody
						size="xs"
						className="mb-1"
						style={{ color: "rgba(255, 255, 255, 0.5)" }}
					>
						Experience
					</TierBody>
					<View
						style={{
							flexDirection: "row",
							alignItems: "center",
							gap: 6,
							paddingHorizontal: 10,
							paddingVertical: 6,
							backgroundColor: "rgba(255, 255, 255, 0.05)",
							borderWidth: 1,
							borderColor: "rgba(255, 255, 255, 0.1)",
							borderRadius: 8,
						}}
					>
						<TierBody size="sm" className="text-base">
							{experienceMode === "theatrical"
								? "🎭"
								: experienceMode === "quick"
									? "⚡"
									: "👑"}
						</TierBody>
						<TierBody
							size="sm"
							className="font-medium"
							style={{ color: "rgba(255, 255, 255, 0.9)" }}
						>
							{experienceMode === "theatrical"
								? "Show"
								: experienceMode === "quick"
									? "Skip"
									: "VIP"}
						</TierBody>
					</View>
				</View>
			)}

			{/* Context Indicator */}
			<View style={{ flex: showExperienceIndicator ? 1 : undefined }}>
				<TierBody
					size="xs"
					className="mb-1"
					style={{ color: "rgba(255, 255, 255, 0.5)" }}
				>
					Context
				</TierBody>
				<View
					style={{
						flexDirection: "row",
						alignItems: "center",
						paddingHorizontal: 10,
						paddingVertical: 6,
						backgroundColor: CONTEXT_COLORS[context].bg,
						borderWidth: 1,
						borderColor: CONTEXT_COLORS[context].border,
						borderRadius: 8,
					}}
				>
					<TierBody
						size="sm"
						className="font-medium flex-1"
						style={{ color: CONTEXT_COLORS[context].text }}
					>
						{t(`context_selector.options.${context}`)}
					</TierBody>
				</View>
			</View>
		</View>
	);
}
